import { Directive, ElementRef, Input, Renderer2, OnInit, SimpleChanges } from '@angular/core';

@Directive({
	selector: '[vbImageLoad]',
	standalone: false
})
export class VbImageLoadDirective implements OnInit {
	@Input() public bgImageUri: string;

	private readonly defaultPlaceholderColorStyle = 'var(--theme-primary-lighten-10) !important';
	private readonly transitionStyle = 'opacity 0.3s ease-in-out';
	private readonly transitionDuration = 300; // matches opacity transition duration

	constructor(
		private readonly el: ElementRef,
		private readonly renderer: Renderer2
	) { }

	public ngOnInit(): void {
		if (!this.hasBgImage() && !this.isImg()) {
			return;
		}

		this.renderer.setStyle(this.el.nativeElement, 'background-color', this.defaultPlaceholderColorStyle);
		this.renderer.setStyle(this.el.nativeElement, 'opacity', '0');
		this.renderer.setStyle(this.el.nativeElement, 'transition', this.transitionStyle);

		if (this.bgImageUri) {
			this.preloadBackgroundImage(this.bgImageUri);
		} else if (this.el.nativeElement?.tagName.toLowerCase() === 'img') {
			this.renderer.listen(this.el.nativeElement, 'load', () => {
				this.renderer.setStyle(this.el.nativeElement, 'opacity', '1');
				setTimeout(() => {
					this.renderer.removeStyle(this.el.nativeElement, 'background-color');
				}, this.transitionDuration);
			});
			this.renderer.listen(this.el.nativeElement, 'error', () => {
				this.renderer.setStyle(this.el.nativeElement, 'background-color', this.defaultPlaceholderColorStyle);
				this.renderer.setStyle(this.el.nativeElement, 'opacity', '1');
			});
		}
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.bgImageUri && !this.isImg()) {
			this.renderer.setStyle(this.el.nativeElement, 'background-image', this.bgImageUri ? `url(${this.bgImageUri})` : '');
		}
	}

	private isImg(): boolean {
		return this.el.nativeElement?.tagName.toLowerCase() === 'img';
	}

	private hasBgImage(): boolean {
		return !!this.bgImageUri?.trim();
	}

	private preloadBackgroundImage(url: string): void {
		const img = new Image();
		img.onload = () => {
			this.renderer.setStyle(this.el.nativeElement, 'background-image', `url(${this.bgImageUri})`);
			this.renderer.setStyle(this.el.nativeElement, 'opacity', '1');
			setTimeout(() => {
				this.renderer.removeStyle(this.el.nativeElement, 'background-color');
			}, this.transitionDuration);
			img.onload = null;
			img.onerror = null;
		};
		img.onerror = () => {
			img.onload = null;
			img.onerror = null;
		};
		img.src = url;
	}
}
